import React from "react";
import uiConfig from "../../config/uiConfig";

import {
  Box,
  TextField,
  MenuItem,
  Button,
  InputAdornment,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import FilterAltIcon from "@mui/icons-material/FilterAlt";



function TicketFilters({

  search,
  setSearch,

  status,
  setStatus,

  priority,
  setPriority,

  category,
  setCategory,

  sortBy,
  setSortBy,

  onApply,
  onReset

}) {


return (

<Box

sx={{

bgcolor:"background.paper",

border:"1px solid",

borderColor:"divider",

borderRadius:2,

p:1.5,

mb:2

}}

>


{/* SEARCH ROW */}

<TextField

fullWidth

size="small"

placeholder="Search by ticket title, ID or employee name..."

value={search}

onChange={(e)=>setSearch(e.target.value)}

InputProps={{

startAdornment:(

<InputAdornment position="start">

<SearchIcon

fontSize="small"

/>

</InputAdornment>

)

}}

sx={{

mb:1.5,

"& .MuiInputBase-root":{

height:38

}

}}

/>







{/* FILTER ROW */}


<Box

display="flex"

alignItems="center"

gap={1.5}

>


<TextField

select

size="small"

label="Status"

value={status}

onChange={(e)=>setStatus(e.target.value)}

sx={{

width:120,

"& .MuiInputBase-root":{

height:36

}

}}

>

<MenuItem value="">
All Statuses
</MenuItem>

<MenuItem value="Open">
Open
</MenuItem>

<MenuItem value="Assigned">
Assigned
</MenuItem>

<MenuItem value="In Progress">
In Progress
</MenuItem>

<MenuItem value="Resolved">
Resolved
</MenuItem>

<MenuItem value="Closed">
Closed
</MenuItem>


</TextField>







<TextField

select

size="small"

label="Priority"

value={priority}

onChange={(e)=>setPriority(e.target.value)}

sx={{

width:120,

"& .MuiInputBase-root":{

height:36

}

}}

>

<MenuItem value="">
All Priorities
</MenuItem>

<MenuItem value="Critical">
Critical
</MenuItem>

<MenuItem value="High">
High
</MenuItem>

<MenuItem value="Medium">
Medium
</MenuItem>

<MenuItem value="Low">
Low
</MenuItem>


</TextField>







<TextField

select

size="small"

label="Category"

value={category}

onChange={(e)=>setCategory(e.target.value)}

sx={{

width:120,

"& .MuiInputBase-root":{

height:36

}

}}

>

<MenuItem value="">
All Categories
</MenuItem>

<MenuItem value="Hardware">
Hardware
</MenuItem>

<MenuItem value="Software">
Software
</MenuItem>

<MenuItem value="Network">
Network
</MenuItem>


</TextField>







<TextField

select

size="small"

label="Sort By"

value={sortBy}

onChange={(e)=>setSortBy(e.target.value)}

sx={{

width:120,

"& .MuiInputBase-root":{

height:36

}

}}

>

<MenuItem value="">
Default
</MenuItem>

<MenuItem value="Newest">
Newest First
</MenuItem>

<MenuItem value="Oldest">
Oldest First
</MenuItem>


</TextField>







<Box

flexGrow={1}

/>







<Button

variant="outlined"

onClick={onReset}

sx={{

height:36,

textTransform:"none",

px:3

}}

>

Reset

</Button>







<Button

variant="contained"

startIcon={<FilterAltIcon/>}

onClick={onApply}

sx={{

height:36,

background:uiConfig.buttonColor,

textTransform:"none",

px:3

}}

>

Apply Filters

</Button>





</Box>


</Box>


);


}


export default TicketFilters;